import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import style from './style.css'

export default class ModalReSyncGrades extends React.Component {
  render () {
    return (
      <Modal show={true} onHide={this.props.onClose} centered className={style.modal}>
        <Modal.Body>
          <p>
              The grades for this assignment will be re-synced in the next 15 minutes. Thank you.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => this.props.onClose()}>OK</button>
        </Modal.Footer>
      </Modal>
    )
  }
}

ModalReSyncGrades.propTypes = {
  onClose: PropTypes.func.isRequired
}
